import { gql } from '@apollo/client';

export const GET_INVENTORY_BY_ID = gql`
  query GetInventoryById($inventory_id: String!) {
    getInventoryById(inventory_id: $inventory_id) {
      status
      message
      inventory_requests {
        inv_id
        status
        inventory_list {
          product_id
          quantity_done
          Aqty
        }
        create_date
        move_type
        stock_type
        date_demande
        date_prevue
        date_done
      }
    }
  }
`;
